module.exports = __webpack_public_path__ + "static/media/chat03-3.17442718.svg";